import { render, staticRenderFns } from "./SettingsNav.vue?vue&type=template&id=5621fd85"
import script from "./SettingsNav.vue?vue&type=script&lang=ts"
export * from "./SettingsNav.vue?vue&type=script&lang=ts"
import style0 from "./SettingsNav.vue?vue&type=style&index=0&id=5621fd85&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports